module.exports = {
  'ryan-thompson': {
    photo: 'ryan-thompson.png',
    fullName: 'Ryan Thompson',
    title: 'College Baseball Advisor',
    bio: [
      `Ryan was a three sport varsity athlete for three years at Dos Pueblos High School, in Santa Barbara, CA. Receiving All-County & All-Channel 
      League honors his junior and senior years, Ryan chose baseball over football when attending UC Davis. Earning his B.A. in Rhetoric & Communication, 
      he then enrolled at the University of San Francisco, graduating with honors while receiving his M.A. in Sports and Fitness Management.`,
      `In 2003, Ryan began his coaching and teaching careers at Cuesta College in San Luis Obispo, CA. From 2008 – 2010. Ryan was the head coach at 
      Scripps Ranch High School in San Diego, CA. In 2010, the program won its first CIF tournament game and league title in the school's history, 
      while Ryan earned league Coach of the Year accolades. Again winning Coach of the Year accolades, this time in 2011 while directing Santa Barbara 
      City College team to the college's first playoff win and super regional appearance in SBCC history. From late 2011 to 2014 he has been working in 
      Major League Baseball as the Cleveland Indian's Southern California Area Scouting Supervisor.`,
      `Ryan currently resides in San Diego, California.`,
    ],
    twitter: 'https://twitter.com/CoachThompsonSF',
    facebook:
      'https://www.facebook.com/people/Coach-Ryan-Thompson/pfbid0n7mXrGGP1hviP5wZxNiTvhiXBW1r7YdLKk2aC1VYuyZ6hBYwsc7K35SHXqAV1Xg1l',
    instagram: '',
    linkedin: '',
    logoList: [
      '485_university_of_california_davis.png',
      'cleveland-indians.png',
      'mlb.png',
    ],
    careerHighlights: [
      'Former MLB Scouting Supervisor for the Cleveland Indians in Southern California and Four Corners Territory',
      '2011 Western State Conference Championship, Coach of the Year; first Junior College player drafted in MLB 2011 Amateur Draft',
      '3 players drafted in MLB 2010 Amateur Draft, SRHS – More than any HS in California',
      'UC Davis Student Athlete Outstanding Senior Award - 2000',
      'Vice President & Recruiting Coordinator TB SoCal Baseball Organization',
      '22 years coaching baseball',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        "Arizona State University, Brown University, CAL, Cal Poly SLO, College of the Holy Cross, Columbia, Cornell University, CSU Fresno, Davidson, Dartmouth, Indiana, Kentucky, Loyola Marymount University, Northwestern University, Ohio State, Pepperdine University, Purdue University, Saint Mary's College of California, San Jose State University, Siena College, Stanford, Penn, UC Davis, UC Irvine, UC Riverside, UC Santa Barbara, UCLA, University of Arizona, University of Hawaii, University of San Diego, University of San Francisco, USC, Washington, Yale University",
      'NCAA D2':
        'Cal Poly Pomona, Colorado Mesa University, Concordia, Chico State, CSU Pueblo, Hawaii Pacific University, Regis, University of Missouri, St. Louis, University of Hawaii - Hilo, Westmont, Western Oregon University',
      'NCAA D3':
        'Adrian, Brandeis University, California Lutheran University, Claremont McKenna College, College of Wooster, George Fox, Lewis & Clark, Linfield College, New York University, Occidental College, Pomona-Pitzer, Rhodes College, Trinity University, University of La Verne, Washington College, Whittier College, Willamette University',
      NAIA: 'Hastings College, Hope International, Westmont College',
    },
    calendly: 'https://calendly.com/rthompson-2117',
  },
  'andrew-beinbrink': {
    photo: 'andrew-beinbrink.jpg',
    fullName: 'Andrew Beinbrink',
    title: 'College Baseball Advisor',
    bio: [
      `Andrew Beinbrink is the CEO and one of the co-founders of SportsForce. He was a 3 sport athlete in high school and former college 
      (Arizona State University) and professional baseball player (Tampa Bay Rays & Texas Rangers).`,
      `Andrew brings a wealth of hands-on college recruiting and sports experience. He is continuously inspired to teach student-athletes, 
      coaches, and parents how to reach their potential, play sports with integrity, and achieve their goals on and off the field. Andrew has 
      personally assisted over 300 student-athletes and families through the college recruiting process.`,
    ],
    twitter: 'https://twitter.com/beinbrink28',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      '25_arizona_state_university.png',
      'tampa-bay-rays-logo.png',
      'texas-rangers-logo.png',
    ],
    careerHighlights: [
      'MLB Amateur Draft 1995 - Drafted14th Round – Boston Red Sox',
      '1995 - Accepted Baseball Scholarship to Arizona State University',
      '4 Time All-American (NCAA DI - Arizona State)',
      'Signed MLB Amateur Draft (7th Round Tampa Rays - 1999)',
      'Six Seasons of Pro Baseball (Tampa Rays & Texas Rangers)',
      '10 Years of College Recruiting Advisory Experience',
      '300+ Players Advised in the Recruiting Process',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Stanford, Oregon, Oklahoma, Tulane, Florida, Harvard, Princeton, University of San Diego, San Diego State, Arizona State, UCLA, Virginia Commonwealth, Kansas, Washington State, Baylor, Columbia, Santa Clara, St. Marys, San Diego State, Navy, Air Force, Georgetown, New Mexico State',
      'NCAA D2':
        'Colorado Mesa, Point Loma Nazarene, Azusa Pacific, UC San Diego, Bellarmine, Merrimack, Slippery Rock, Mercyhurst',
      'NCAA D3':
        'Amherst, Chapman, University of Chicago, Pomona-Pitzer, Salsbury, Johns Hopkins, MIT, Trinity (TX), Redlands, Stevens Institute, Swarthmore, Clairemont McKenna, Bates, Haverford, Dickinson, Washington & Lee, Occidental, Wooster, Catholic University, Gettysburg, Franklin & Marshall, St. Marys, La Verne',
      NAIA: 'Westmont, William Jessup, Corban, Georgetown College, Grand View, Hope International, Judson, Lewis-Clark College, Providence Christian, Robert Morris, Vanguard, York',
    },
    calendly:
      'https://calendly.com/abeinbrink/college-scouting-evaluation?back=1',
  },
  'john-bava': {
    photo: 'john-bava.jpg',
    fullName: 'John Bava',
    title: 'College Baseball Advisor',
    bio: [
      `John has played, coached & worked in sports for the past 30 years. John began playing baseball competitively at an early age and continued 
      to improve as an athlete, earning All-League & All-American honors in baseball his senior year at Thomas Downey High School in Modesto, CA. 
      After his playing career was over, he began his coaching career as a private hitting instructor and working in professional baseball with the 
      River Cats organization.`,
      `He has been coaching and advising baseball players for the past 16 years, connecting many with college programs at all levels DI,II,III, and NAIA. 
      Most recently coaching at San Joaquin Delta College (JC) as an Asst Coach and Recruiting Coordinator, helping with their recruiting efforts.`,
    ],
    twitter: 'https://twitter.com/JohnJBava',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'cccaa-logo.png',
      'San_Joaquin_Delta_College.png',
      'oakland-athletics-logo.svg',
    ],
    careerHighlights: [
      '1992 led Thomas Downey HS to a CIF sub-section championship game',
      '1993 All-League Catcher, Thomas Downey HS',
      '1993 Stanislaus County All-District team',
      '1993 Mizuno HS All-America',
      '6+ years as SportsForce Recruiting Advisor',
      'Assistant Coach/Recruiting Coordinator at San Joaquin Delta College',
      '16+ years of coaching/recruiting experience',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        "Cal Berkley, Northern Arizona, UC Davis, Sacramento State, Loyola Marymount, U of Hawaii, University of San Diego, Valpraiso, Portland State, Oregon State, U of Montana, Grand Canyon U, St. Mary's, U of Colorado, Colorado Springs",
      'NCAA D2':
        'CSU Stanislaus, Humbodt State, Chico St, Lincoln University, Concordia University - Portland',
      'NCAA D3':
        'UC Santa Cruz, University of Redlands, Menlo College, University of LaVerne, Chapman University, LaGrange (GA), Otterbein U (OH), Macalaster (MN), Linfield (OR), Occidental (CA), Pomona-Pitzer (CA), Claremont Mudd Scripps Colleges, Willamette (OR)',
      NAIA: '',
    },
    calendly: 'https://calendly.com/john-bava',
  },
  'kevin-klaess': {
    photo: 'kevin-klaess.jpg',
    fullName: 'Kevin Klaess',
    title: 'College Baseball Advisor',
    bio: [
      `I was a 2 sport 3-year letterman for both football and baseball, earning all-Conference honors in both
      sports and making the Orange Country North South all-star team in baseball. I got recruited to play both
      football and baseball, but I knew I had a better chance of playing baseball at a professional level. I
      turned down football scholarships to play baseball, continuing my education at Cypress College winning
      a state championship in 2013 while getting my A.A. in Business Administration. Cypress helped me get
      recruited to Lindsay Wilson college on a ninety percent scholarship. From there I transferred, doing my
      own recruiting, to Chapman University where they were able to help get grants up to seventy percent of
      tuition for good academic grades throughout high school and college. While finishing my collegiate
      playing career at chapman and I earned my B.A. in Business Management After that I was able to play
      Independent Professional Baseball for the next 3 years.`,
      `I started coaching youth travel ball while finishing up my last year of pro ball. We have built up an
      organization that helps train all ages from youth to college. We have had the pleasure of helping many
      players reach their dreams of playing baseball at the next level. We have sent numerous players to the
      collegiate level and even helped some get drafted. I am also a varsity high school coach with Marina in
      Huntington beach. I am also a Private Personal Training both as a baseball instruction and a Certified
      Fitness trainer through NCSF. My passion has always been to help others reach their highest level of
      potential and allow players to play at the next level. I have seen personally what this game can do and
      how it can transform players as it helps prepare them for the rest of their lives as they make it to the
      highest level they can play. It’s an honor to be a part of the process that gives players an opportunity
      they never thought they would be able to reach. Guiding families through the recruiting process as well
      as make sure their players continue to develop in a fashion that meets college recruiting requirements is
      the most satisfying way, I can give back to the game that has given me everything.`,
    ],
    twitter: 'https://twitter.com/kevinKlaess',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'ncaa-logo.png',
      'naia-logo.png',
      '85_chapman_university.png',
      'Cypress_College.png',
      '1851_lindsey_wilson_college.png',
    ],
    careerHighlights: [
      `2007-2011 Huntington Beach High school Baseball and football, 3-year Varsity for both sports, All Sunset
      league 2nd team/ all-academic team football. Baseball All sunset league 1 st team/ all-academic team /
      Orange County North, South All-star team.`,
      `2016- Present, 8 years of Coaching experience. 2 years of high school coaching with Marina High School;
      8 years with both travel ball organizations Prevail Baseball/ Stacked Recruiting`,
      '2011-2013, Cypress College- 2013 CCCAA State Championship',
      '2013-2014, Lindsay Wilson College- NAIA- 90% scholarship',
      '2014-2015, Chapman University- B.A. in Business Management',
      '2015-2017, Independent Professional Baseball',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Long Beach, New Mexico State, Fresno State, UCSB, UCLA, USC, UCSD, UCI',
      'NCAA D2': 'Colorado Mesa University, Biola',
      'NCAA D3': 'Chapman',
      NAIA: 'Hope International',
      NJCAA: 'Cypress College, Orange Coast College, Golden West College',
    },
    calendly: 'https://calendly.com/kklaess',
  },
  'max-gunn': {
    photo: 'max-gunn.jpeg',
    fullName: 'Max Gunn',
    title: 'College Baseball Advisor',
    bio: [
      `Max brings 7 years of coaching and recruiting knowledge to SportsForce. He played Division 3 College Baseball at Thiel College 
      for two years before transferring back home to Ohio State. He currently coaches Varsity High School Baseball in Central Ohio. There, 
      he handles all recruiting for the High School. In the last 4 years, he has helped place 26 student athletes to play at the next level. 
      He also holds the Director of Baseball position for a summer organization in Central Ohio. In that role, he runs recruiting and assists 
      with the transition from Middle to High School Baseball, as well as, High School to College.`,
      `He currently resides in Central Ohio where he is a Special Education teacher and coaches high School baseball. He loves spending time with 
      his Wife Carly and Daughter Josie. He thoroughly enjoys building relationships and assisting in finding a forever home for student athletes. 
      Being a teacher, he gets joy out of seeing student athletes achieve their goals and enjoys being a part of that process. He is willing to go 
      the extra mile and put in whatever amount of work necessary to help achieve a players dreams and aspirations. `,
    ],
    twitter: 'https://twitter.com/CoachG32',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['466_thiel_college.png', 'ncaa-logo.png'],
    careerHighlights: [
      'Former Division 3 Baseball Player',
      'Current Varsity Baseball Coach',
      '6 years of College Recruiting',
      '26 Student Athletes placed to play at the next level',
      'Director of Baseball for Central Ohio Organization',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'University of Cincinnati, Wagner University, Ohio State University, Akron University',
      'NCAA D2': 'Lake Erie College',
      'NCAA D3':
        'Defiance College, Adrian College, Wilmington College, Wittenberg University, Chatham University, Geneva College, Earlham College, Thiel College, Ohio Wesleyan University, Muskingum University, Anderson University, Marietta College',
      NAIA: 'Saint Xavier University, University of Northwestern Ohio',
      NJCAA: 'Bryant and Stratton College',
    },
    calendly: '/webformlp',
  },
  'andrew-olla': {
    photo: 'andrew-olla.jpeg',
    fullName: 'Andrew Olla',
    title: 'College Baseball Advisor',
    bio: [
      `Andrew brings 10 plus years of coaching, scouting, and recruiting knowledge to SportsForce. Andrew also had a brief stint coaching at the 
      University of Concordia (NCAA D3) before moving into professional scouting with the Milwaukee Brewers (MLB).`,
      `Now Andrew is the recruiting coordinator for Building Champions Baseball Academy with 300 plus college placed players and 30 plus MLB draft picks. 
      He has helped players achieve college dreams like LSU, Kansas State, Kansas, Oklahoma, and Arkansas to name a few for many kids averaging roughly 
      30 kids a year into college programs. During this time he also serves as an associate scout for the Philadelphia Phillies for the last 3 years.`,
      `Andrew was a 2-sport athlete at West Allis Central HS in Milwaukee Wisconsin (baseball/soccer). After that, Andrew got involved in coaching baseball 
      at Kewaskum High School. Coaching there for 6 years where they won 5 conference championships and placed several college athletes.`,
    ],
    twitter: 'https://twitter.com/Drew_Olla',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'ncaa-logo.png',
      'philadelphia-phillies-logo.png',
      'mlb.png',
      '113_concordia_university_wi.png',
    ],
    careerHighlights: [
      'Former College Coach University of Concordia Wisconsin (NCAA D3)',
      '2015 MLB Scout School Graduate',
      '5 years of Pro Scouting',
      'Former High School Coach at Kewaskum (Wisconsin)',
      '7 years of College Recruiting Coordinator - Academy Level',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Arkansas, Oral Roberts, Texas AM Corpus Cristi, Oklahoma, LSU, Creighton, Kansas, Kansas State, Southern Illinois Edwardsville, University of St. Louis, Wichita State, Nebraska,University of Texas San Antonio, Arizona State, Murray State, Missouri State, Saint Joesp’s University, has University of Missouri, Arkansas State, Southeast Missouri State, University of Milwaukee Wisconsin, Ball State University',
      'NCAA D2':
        'University of Central Missouri, Drury University, Northwest Missouri State, University of Missouri St. Louis, Emporia State, Pittsburg State, Washburn University, Missouri Southern, Truman State,',
      'NCAA D3':
        'Wisconsin Whitewater, University of Wisconsin Oshkosh, University of Concordia, Hendrix College, University of Washington of St. Louis. University of Wisonsin Steven Point, Carroll College, University of Wisonsin Lutheran, Grinnell College',
      NAIA: 'Benedictine College, Central Methodist, University of Concordia Nebraska, Park University',
      NJCAA:
        'Johnson County CC, Barton County CC, Neosho County CC, San Joaquin Delta College, Cowley County CC, Madison CC, Kansas City CC, Maple Woods CC, St. Louis CC',
    },
    calendly: 'https://calendly.com/andrewolla',
  },
  'auburn-donaldson': {
    photo: 'auburn-donaldson.png',
    fullName: 'Auburn Donaldson',
    title: 'College Baseball Advisor',
    bio: [
      `I grew up playing all sports. I played baseball at Baker High School. We were Alabama 6A State Champions in 2005 & 2006. I played 2 years of Junior 
      College at College of Marin in California. My Junior Year at Southeastern University in Lakeland, FL led to being drafted by the Baltimore Orioles in 2010. 
      I am grateful & fortunate to have had the opportunity to compete with the best in the game! I graduated from the University of South Alabama earning 
      a Bachelor of Science in Business Administration.`,
      `During 2016-2020, I assisted my brother and my family through the recruiting process. Myles White competed at Dothan-Wallace Community College for 2 years. 
      Currently, he is competing at Division 1, Jackson State University. I coached one season at Dothan-Wallace CC under Mackey Sasser. We finished 2nd in the 
      State. I spend the summers coaching in Collegiate Leagues.`,
      `Navigating the recruiting process can be a daunting task. Establishing and building key relationships within communities is our focus. We want to provide 
      the best resources available for student-athletes and families. My decision to join a team of like-minded individuals who share the same passion was simple.`,
    ],
    twitter: 'https://twitter.com/j_auburn88',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'College_of_Marin.png',
      '1801_southeastern_university.png',
      'baltimore-orioles-logo.png',
      'Wallace_Community_College.png',
      'naia-logo.png',
    ],
    careerHighlights: [],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Jackson State University, University of Florida, Troy University, University of South Alabama, Marshall University, Georgia Southern University, Jacksonville State University, Bethune-Cookman University',
      'NCAA D2':
        'University of Alabama at Huntsville, Columbus State University',
      'NCAA D3': 'Huntingdon College',
      NAIA: 'Tennessee Wesleyan University, University of Mobile',
      NJCAA:
        'Bishop State Community College Southern Union Community College, Andrew College , Dothan-Wallace Community College, Wallace Selma Community College',
    },
    calendly:
      'https://calendly.com/sports_advising_fundraising/evaluation-call',
  },
  'braden-persian': {
    photo: 'braden-persian-v2.jpeg',
    fullName: 'Braden Persian',
    title: 'College Baseball Advisor',
    bio: [
      `Braden is currently a Head Coach in the Power Summer Collegiate League and the Mainland British Columbia Director of Scouting for Prep Baseball Report. 
      Braden also works as a coach with the Abbotsford Cardinals in the British Columbia Premier Baseball League.`,
      `Braden's extensive coaching experience includes the University of Calgary Dinos, Douglas College Royals, Calgary Bucks, White Rock Tritons, Top 40 
      Provincial teams in Alberta and BC and Big League Experience.`,
      `Braden is driven by watching his players develop, grow and achieve their baseball dreams. He is passionate about sharing his knowledge of baseball and 
      enjoys nothing more than being on the diamond.`,
      `Braden currently resides in White Rock, British Columbia with his wife Madi and his dog Dirk.`,
    ],
    twitter: 'https://twitter.com/BradenPersian',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'nwac-logo.png',
      'pbr-logo.jpeg',
      'calgary-dinos-logo.png',
      'douglas-college-royals.jpeg',
    ],
    careerHighlights: [],
    myPlayerCollegesByDivision: {},
    calendly: 'http://calendly.com/bradenpersian',
  },
  'cliff-brown': {
    photo: 'cliff-brown-v2.jpg',
    fullName: 'Cliff Brown',
    title: 'College Baseball Advisor',
    bio: [
      `Coach Cliff brings a wealth of experience to Sports Force.  Cliff joined the coaching staff at Lindenwood University as the Director of Player Development 
      in August of 2022 after serving as an Assistant Coach at the University of Missouri- St. Louis during the 2022 season.  Prior to that, he served as the Head 
      Coach at Harper College for 10 years. During his tenure at Harper, Cliff oversaw the development of 31 All-Conference Players, 27 All-Region selections, and 
      3 NJCAA All-Americans.`,
      `In total, Cliff has 29 years of professional and amateur coaching experience and spent 23 years coaching at the college level.  He has coached at the 
      Division I, Division II, and Junior College level and has coached 40 players that have gone on to play professional baseball.`,
      `Cliff spent 3 years working in the Chicago White Sox organization.  He spent one season as a Strength and Conditioning Coach for the White Sox Rookie Ball 
      team. He also oversaw all operations of the White Sox Training Academy in Lagrange, IL where he worked with players of all ages in hitting, pitching, and 
      catching.`,
    ],
    twitter: 'https://twitter.com/cwbrown38',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      '243_lindenwood_university.png',
      '1034_university_of_missouri_st_louis.png',
      '2193_william_rainey_harper_college.png',
      'ncaa-logo.png',
      'chicago-white-sox-logo.png',
    ],
    careerHighlights: [],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachcliffbrown38/60min?',
  },
  'john-cackowski': {
    photo: 'john-cackowski-v2.png',
    fullName: 'John Cackowski',
    title: 'College Baseball Advisor',
    bio: [
      `John has been part of the Colorado amateur baseball landscape for 30 years. He graduated Highlands Ranch HS in 1992. John went on to play 2 years of 
      college baseball at Colorado Northwestern, and from there went to Colorado State University and received a bachelor degree in History. After graduating 
      college, John started his professional career at ThunderRidge HS in the fall of 1997. He was a varsity baseball assistant from 1997 to 2006, helping the 
      program win its first baseball state championship in 2004. John was also the head softball coach from 2002 to 2006 earning Coach of the Year honors in 2002 
      after winning the Continental League championship for the first time in program history. He would finish with a career winning percentage of 640%, making 
      the state playoffs every year including the Final 8 and Final 16.`,
      `In 2006, John had an opportunity to become the head baseball coach at his alma mater -Highlands Ranch. In his first-year coaching, John won Continental 
      League Coach of the Year honors after winning the Continental League. Highlands Ranch would make the playoffs the next 6 years, something that they had 
      not accomplished in the previous 5 years before John arrived. In 2011 and 2012, Highlands Ranch would make back-to-back 5A Final Four appearances for the 
      first time in program history, while reaching a national ranking of 18 by Baseball American in 2012. John would finish with a .610 winning percentage at 
      Highlands Ranch.`,
      `John was also coach and scout for USA baseball, and a professional scout for 8 years for multiple organizations.`,
      `John currently resides in Highlands Ranch, Colorado, and is married to his wife, Natalie. He has a daughter who is a sophomore at Colorado State, and a 
      son who is a junior at Arapahoe High School. John is currently coaching baseball at Arapahoe High School.`,
    ],
    twitter: 'https://twitter.com/cack92',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['njcaa-logo.png', 'usa-baseball-logo.png', 'pbr-logo.jpeg'],
    careerHighlights: [
      '30 + years of coaching amateur baseball in Colorado',
      'Head varsity baseball and softball coach combined for 15 years',
      'Coached and scouted for USA Baseball from 2008 to 2014',
      'Professional baseball scout for 9 years with multiple organizations',
      'Coached 9 players who would go on to get drafted',
      '57 previous players went on to play at the college level',
      'Launched PBR Colorado/Wyoming and was state director for 6 years'
    ],
    myPlayerCollegesByDivision: {},
    calendly: '/webformlp',
  },
  'kyle-skinner': {
    photo: 'kyle-skinner-v2.jpg',
    fullName: 'Kyle Skinner',
    title: 'College Baseball Advisor',
    bio: [
      `Kyle Skinner is more than an educator and coach—he's a guiding force in the journey of aspiring student-athletes. With a robust academic background and 
      extensive coaching experience, Kyle brings a wealth of knowledge and insight to the world of college baseball recruiting. Kyle's academic journey began 
      at West Los Angeles College, where he earned an Associate of Science in Physical Education in 2009. Building on this foundation, he obtained a Bachelor's 
      degree in Exercise Science & Sports Management from Valley City State University in 2012. Kyle then pursued his passion for teaching, earning a Master's 
      in Teaching with a specialization in Health & Fitness from Northwest University in 2015.`,
      `Transitioning seamlessly into a professional role, Kyle has dedicated himself to shaping young minds as a Physical Education & Health Teacher since 2015. 
      However, it's his extensive coaching background that truly sets him apart. As the Head Varsity Baseball Coach at Interlake High School in Bellevue, WA, 
      from 2015 to 2023, Kyle honed his skills in player development and mentorship. Kyle's coaching tenure extends beyond the high school level. He has held 
      pivotal roles with prestigious teams such as the Boys of Summer Raptors 18u College Showcase team and the St. Louis Cardinals Area Code Scout Team, where 
      he served as Field Manager and Assistant Coach during an MLB Scouting Externship in 2012. Beyond coaching, Kyle has been instrumental in the success of 
      numerous players in their college baseball endeavors. His leadership positions at Inglemoor and Bellevue High Schools, along with his involvement with 
      the Sammamish Baseball Academy and Let’s Play: Professional Baseball Instruction, underscore his commitment to fostering talent at every level.`,
      `Kyle's dedication to continuous improvement is evident in his pursuit of prestigious certifications, including those from the National Strength & Conditioning 
      Association and the United States Sports Academy. Furthermore, his own collegiate baseball career was distinguished by numerous awards and scholarships, 
      reflecting his prowess both on and off the field.`,
      `Kyle's impact transcends individual achievements; it's reflected in the success stories of the players he has mentored. Kyle's players have found success 
      at various levels of collegiate baseball. In summary, coach Skinner isn't just a coach or a teacher—he's a mentor, a guide, and a dedicated advocate for 
      student-athletes. His journey from celebrated student-athlete to respected educator and coach speaks volumes about his commitment to fostering talent and 
      promoting healthy, active lifestyles. If you're looking to navigate the complex landscape of college baseball recruiting, Kyle Skinner is your trusted 
      advisor every step of the way.`,
    ],
    twitter: 'https://twitter.com/CoachSkinner11',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      '1856_valley_city_state_university.png',
      'northwest_university.png',
      'naia-logo.png',
    ],
    careerHighlights: [
      'Northwest University, 2015 - Masters in Teaching: Health & Fitness',
      'Head Varsity Baseball Coach, 2015-2023 - Interlake High School - Bellevue, WA',
      'Field Manager/Assistant Coach, 2012 - St. Louis Cardinals Area Code Scout Team - MLB Scouting Externship',
      'Director of Strength & Conditioning - Sammamish Baseball Academy',
      'Certified Sports Psychology Coach - National Exercise & Sports Trainers Association (NESTA)',
      'American Baseball Coaches Association',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Saint Peters University, Campbell University, Marshall University, Seattle University, University of Northern Colorado, University of San Fransisco, University of Washington, Washington State University, William & Mary',
      'NCAA D2': 'Cal State San Bernardino',
      'NCAA D3':
        'Chapman University, Claremont McKenna College, Linfield University, Luther College, Occidental College, Pacific Lutheran University, Pacific University, University of Puget Sound',
      NAIA: 'Eastern Oregon University, University of Jamestown',
      NJCAA:
        'San Joaquin Delta, Bellevue College, Blue Mountain Community College, Columbia Basin College, Edmonds College, Green River College, Skagit Valley College, Umpqua Community College, Williston State College, Yuba College',
    },
    calendly: 'https://calendly.com/coachskinner11',
  },
  'matt-sugarman': {
    photo: 'matt-sugarman.jpg',
    fullName: 'Matt Sugarman',
    title: 'College Baseball Advisor',
    bio: [],
    twitter: 'https://twitter.com/CoachSug',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['ncaa-logo.png', 'pbr-logo.jpeg'],
    careerHighlights: [],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachsugarmanaz',
  },
  'nino-giarratano': {
    photo: 'nino-giarratano-v2.jpeg',
    fullName: 'Nino Giarratano',
    title: 'College Baseball Advisor',
    bio: [],
    twitter: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['ncaa-logo.png', 'njcaa-logo.png', 'usa-baseball-logo.png'],
    careerHighlights: [],
    myPlayerCollegesByDivision: {},
    calendly: '/webformlp',
  },
  'caleb-cox': {
    photo: 'caleb-cox.png',
    fullName: 'Caleb Cox',
    title: 'College Baseball Advisor',
    bio: [
      `Caleb Cox was named the eighth, and youngest, head coach in Garden City Community College Baseball history in June 2022.  
      He came to Garden City after a one-year stint as an assistant at Regis University in Colorado.  There, he coached pitchers 
      and catchers and oversaw recruiting operations. That season, the Rangers took second in the Rocky Mountain Athletic 
      Conference, their highest finish in school history. Cox also helped mold First-Team All-Conference pitcher, Justin 
      Kleinsorge, who led the conference with 103 punchouts.`,
      `Before Regis, Cox was a graduate assistant at Colorado State-Pueblo. Prior to that, he spent the 2020 season as the 
      catcher's coach at Butler Community College, helping guide the Grizzlies to a 15-4 mark before the season was canceled 
      due to COVID.`,
      `Cox began his collegiate playing career as a catcher at Butler Community College. He then signed with Arkansas 
      Little-Rock before transferring to Pittsburg State to finish his career.`,
      `Cox grew up in Broomfield, Colorado and is the son of former big leaguer Darron Cox, and other brother of Jonah Cox; 
      who led Oral Roberts University to the Men's College World Series in 2023 with his 47 game hit streak. He earned his 
      bachelor's degree from Pittsburg State University, and currently resides in Colorado Springs, Colorado with his wife 
      Brittany and son Beckham.`,
      `"The greatest joy in my baseball career is the moment my players have told me their plans for commitment at the collegiate level.  To see a young man's progression from an initial conversation about their dream of playing college baseball- walking with them through the training and recruiting process; then, come to fruition on signing day are moments I will always remember and cherish." `,
    ],
    twitter: 'https://twitter.com/calebcox303',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'njcaa-logo.png',
      'ncaa-logo.png',
      '362_regis_university_co.png',
      '699_colorado_state_university_pueblo.png',
      '997_university_of_arkansas_little_rock.png',
      '904_pittsburg_state_university.png',
    ],
    careerHighlights: [
      `Catcher at Butler Community College, University of Arkansas- Little Rock and Pittsburg State University.`,
      `2017 NBC All-American`,
      `Catching Coordinator- Butler Community College`,
      `Graduate Assistant Coach/Operations Coordinator- Colorado State University- Pueblo`,
      `Assistant Coach/Recruiting Coordinator- Regis University`,
      `Head Baseball Coach- Garden City Community College`,
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Central Arkansas University, University of Arkansas- Little Rock, Southeastern Missouri University, Gardner-Webb University, University of San Francisco, University of Northern Colorado, South Dakota State University, Wichita State University, University of Kansas, Grambling State University, Creighton University.',
      'NCAA D2': `University of Central Oklahoma, Northern State University, Newman University, Emporia State University, Northwestern Oklahoma State University, Southwestern Oklahoma State University, Pittsburg State University, Missouri Western State University, Northwest Missouri State University, William Jewell University, Holy Family University, St. Edward's University.`,
      'NCAA D3': 'Curry College',
      NAIA: 'LSU-Alexandria, Clarke University, Park University, Belleview University',
      NJCAA: '',
    },
    calendly: 'https://calendly.com/coach-caleb-cox',
  },
  'ryan-sloniger': {
    photo: 'ryan_sloniger.jpg',
    fullName: 'Ryan Sloniger',
    title: 'College Baseball Advisor',
    bio: [
      `Ryan was a two-sport athlete at Punxsutawney area High School in Punxsutawney, PA. While at Punxsutawney he was a part of 4 District Championship's. 
      He received All-State honors three times, player of the year twice, and was a Team MVP three times. Ryan holds the school career records for Hits, Doubles, 
      & RBI's. After High School, Ryan went on to play at Penn State University where he had 166 career starts over 4 years as a catcher. He ranks fourth all time 
      in career putouts. After Ryan graduated from Penn State, he got drafted by the Toronto Blue Jays in the 38th round. He played in 3 levels of minor league 
      baseball over 3 years.
      
      Ryan began his coaching career immediately after being done playing professional baseball. He started as a volunteer assistant at Kent State working with 
      the Catchers and Pitchers. The next summer he became the Pitching Coach & Recruiting Coordinator at Gardner-Webb University, where he coached 3 all 
      conference pitchers including the conference pitcher of the year. He then went back to Kent State University to coach Pitchers/Catcher and assist with 
      recruiting responsibilities. 

      Ryan currently resides with his wife Alyssa in Bellefonte , PA.
    
      I have a passion for helping players understand the recruiting process and helping them find a home. I love being able to see a player finally understand 
      that all the work they are putting in his paying off for them.`,
    ],
    twitter: 'https://x.com/R_Sloni4',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: [
      'penn_state_logo.png',
      'blue_jays_logo.png',
      '794_kent_state_university.png',
      '756_gardner_webb_university.png',
    ],
    careerHighlights: [
      '7 Years Playing at the Division 1/Professional Level',
      '3 Years Division 1 Assistant Baseball Coach',
      'College Summer Baseball League Head Coach (2020)',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'Kent State University, Liberty, Maryland Eastern Shore, Radford',
      'NCAA D3': "Penn State Harrisburg, Saint John's University",
    },
    calendly: 'https://calendly.com/coachsloniger4',
  },
  'jeremy-faoro': {
    photo: 'jeremy-faoro.jpg',
    fullName: 'Jeremy Faoro',
    title: 'College Baseball Advisor',
    bio: [
      `Jeremy was a two-sport athlete out of Mount Si High School in Snoqualmie Washington and played baseball at Pierce College. 
    Due to an injury, he was forced to quit playing and joined the coaching world.`,
      `In 2004 Jeremy started coaching football at Chief Kanim Middle School. That following spring Jeremy started coaching baseball at Mount Si High School. 
    He has been coaching baseball for 20 years now out of Mount Si. Over his time there he has several Kingco Championships as well as 1 State Championship 
    and two other state finalists. Jeremy also has 15 years coaching in the Summer Travel ball world. He is currently the Head Coach for the Washington A's 
    18u Premier team.`,
      `Jeremy has two children with his Wife Stefanie Faoro, and they reside in Issaquah WA.`,
    ],
    twitter: 'https://x.com/coachfaoro',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['Pierce_College_at_Puyallup.jpg'],
    careerHighlights: [
      '2011 WIAA 3A State Champion',
      '2012 WIAA 3A State Semi Finalist',
      '2013 WIAA 3A State Semi Finalist',
      '9 players drafted in the MLB Draft',
      '20 Years Coaching High School Baseball',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        "University of Washington, Washington State University, Gonzaga University, Oregon State University, University of Oregon, Seattle University, Yale University, Texas Tech University, Kansas State University, New Mexico State University, University of Illinois, University of San Fransisco, Santa Clara University, University of Arizona, University of Connecticut, University of Hawai'i, University of Louville, Seattle Pacific University, Boise State University, University of Northern Colorado",
      'NCAA D2':
        "Azuza Pacific University, Central Washington University, University of Charleston, Colorado School of Mines, Hawai'i Pacific University",
      'NCAA D3':
        'Whitworth University, Whitman College, University of Puget Sound, Pacific Lutheran University, University of Redlands, Colby College, George Fox University, Lewis and Clark College, Linfield College, Pacific University, Willamette University',
      NAIA: '',
      NJCAA:
        'Bellevue College, Pierce CC, Tacoma CC, Linn-Benton CC, Lower Columbia CC, Everett CC, Shoreline CC, Spokane CC, Columbia Basin CC, Wenatchee Valley CC, Walla Walla CC, Yakima CC, Centralia CC, Central Arizona CC, Chattanooga State CC',
    },
    calendly: 'https://calendly.com/coachjfaoro',
  },
  'michael-mcnamara': {
    photo: 'michael-mcnamara.jpg',
    fullName: 'Michael McNamara',
    title: 'College Baseball Advisor',
    bio: [
      `I have a strong passion for helping young student athletes and their families find a home for the next 4 years of their lives. The recruiting process can 
      be very confusing and complex, and I am here to simplify and assist along the way.`,
      `I played varsity football and baseball at Saint Ignatius High School in 
      Cleveland Ohio and won the OHSAA baseball state championship in 2019. After graduating in 2020, I decided to play baseball over football at Kent State 
      University. I studied Sports Administration and Business throughout my 4 years there. In 2023, we won the MAC regular season and had 42 wins throughout 
      the season, resulting in one of the best seasons in Kent State's history.`,
    ],
    twitter: 'https://x.com/mmac828',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['794_kent_state_university.png'],
    careerHighlights: [
      '2nd team All-MAC in 2021 and 2022',
      'All-MAC defensive team in 2021 at Kent State University',
      '6th all-time in home runs at Kent State University with 39.',
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachmcnamara8',
  },
  'mike-burtner': {
    photo: 'mike-burtner.jpeg',
    fullName: 'Mike Burtner',
    title: 'College Baseball Advisor',
    bio: [
      `Mike was a three-sport athlete at Bridgewater College where he was a member of the 1994 ODAC Championship and NCAA Regional team in baseball while 
      earning a BS degree in Computer Science.  He later earned a Master of Engineering degree in Systems Engineering from Old Dominion University.`,
      `In 2001, Mike began coaching the Elkton Blue Sox in the Rockingham County Baseball League and was named the RCBL Manager of the Year three times in a 
      seven-year span while winning 2 regular season and 1 playoff championships. Mike also coached 8 MLB Draft picks and numerous other Division 1 players. 
      In 2024, Mike was inducted into the Rockingham County Baseball League's Hall of Fame.`,
      `After coaching in the RCBL, Mike turned his focus to coaching youth and travel baseball and has amassed 25 years of coaching experience.  In just the 
      last 4 years, over 60 players from Mike's travel teams have gone on to play college baseball at just about every level.`,
      `Mike currently resides near Harrisonburg, VA.`,
    ],
    twitter: 'https://x.com/coachburtner',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['54_bridgewater_college_va.png'],
    careerHighlights: [
      'Inducted into the Rockingham County Baseball League Hall of Fame (2024)',
      'Co-Founder of Valley Elite travel baseball program',
      'Member of 1994 ODAC Championship Team at Bridgewater College',
      '25 years of coaching experience',
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1':
        'University of Virginia, James Madison University, Longwood University, Virginia Military Institute, Charleston Southern, Samford University, University of Maryland-Baltimore County, Liberty University, Old Dominion University, Brown University, Dartmouth University, William & Mary',
      'NCAA D2':
        'Tampa University, Fairmont State University, Concord University, University of Charleston, Salem University, Shepherd University, Emory & Henry College',
      'NCAA D3':
        'Bridgewater College, Eastern Mennonite University, Mary Baldwin University, Ferrum College, Shenandoah University, Christopher Newport University, McDaniel College, Southern Virginia University, University of Lynchburg, Randolph Macon College',
      NAIA: 'Bluefield University, West Virginia Tech',
      NJCAA:
        'Potomac State, Lehigh Carbon Community College, Frederick Community College, Richard Bland College, Virginia Peninsula Community College, Bryant & Stratton College, Lenior Community College, Wake Tech Community College, Patrick & Henry Community College, New River Community College',
    },
    calendly: 'https://calendly.com/coachburtner',
  },
  'petey-torres': {
    photo: 'petey_torres.jpg',
    fullName: 'Petey Torres III',
    title: 'College Baseball Advisor',
    bio: [
      `Born and raised in the Bay Area, California, Petey Torres III has dedicated his life to the game of baseball, excelling as both a player and a coach. 
      Petey’s journey began as a four-year high school varsity starter, earning All-MEL Team honors from his sophomore to senior year.`,
      `He continued his baseball career at Santa Rosa Junior College, where he played for a nationally ranked team for three consecutive years. Petey then advanced to Clarke University 
      from 2020 to 2022, where he earned recognition as a Gold Glove winner at catcher in 2021 and was named to the Heart of America Conference 2nd Team the same year. His journey in collegiate 
      baseball continued as he played Division II baseball at the Academy of Arts in 2023.`,
      `Beyond his playing career, Petey has shifted his focus to helping develop the next generation of baseball talent. He is currently collaborating with over 30+  families, providing guidance 
      and training to young athletes under his own training business "PT3 Fundamentals"  Petey also played a key role in the founding and development of the Cepeda Sports travel ball organization, 
      where he shares his expertise and passion for the sport.`,
      `Petey’s commitment to fostering both physical skills and mental resilience in athletes reflects his dedication to building well-rounded players who excel on and off the field.`,
    ],
    twitter: 'https://x.com/Coachpete00',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['Santa_Rosa_Junior_College.png', '1791_Clarke_University.png'],
    careerHighlights: [
      `Four-Year High School Varsity Starter: Earned All-MEL Team honors from sophomore to senior year`,
      `Santa Rosa Junior College: Played for a nationally ranked team for three consecutive years`,
      `Clarke University Alumni: Gold Glove winner at catcher in 2021 and Heart of America Conference 2nd Team selection`,
      `Division II Player: Competed at the Academy of Arts in 2023`,
      `Coaching and Development: Collaborating with over 25 families to train and guide young athletes`,
      `Cepeda Sports: Co-founder of a travel ball organization focused on player development`,
    ],
    myPlayerCollegesByDivision: {
      'NCAA D2': 'Academy of Art Institute',
      NAIA: 'Clarke University',
      NJCAA: 'Santa Rosa Junior College',
    },
    calendly: 'https://calendly.com/coachpete00',
  },
  'gavin-napier': {
    photo: 'gavin_napier.jpg',
    fullName: 'Gavin Napier',
    title: 'College Baseball Advisor',
    bio: [
      `I attended Granada High School where I was a 3-year starter on varsity where I received multiple All-EBAL honors my sophomore and junior year. 
      After graduating from Granada, I decided to attend Saint Mary's College of California. During my time at SMC, I was able to play and start for all 
      4 years while earring a Bachelor's Degree in Sports Management.`, 
      `After my playing days were over, I knew I wanted to still be involved in baseball and started coaching at Los Medanos College. I have always had a 
      passion for baseball and helping other people, and I felt like becoming an advisor is a great way to help players in a similar situation I was in and 
      to be a resource to help them achieve their dreams.`
    ],
    twitter: 'https://x.com/Gavin_Napier_2',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['ncaa-logo.png'],
    careerHighlights: [
      'All-EBAL Second Team, Iron Gael Award Recipient',
      '3x Student-Athlete of the Week',
      '2022 WCC All-Academic Team'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachnapier2',
  },
  'chris-vaculik': {
    photo: 'chris_vaculik.jpg',
    fullName: 'Chris Vaculik',
    title: 'College Baseball Advisor',
    bio: [
      `From 2004-2007, I was a Division 1 Athlete at Eastern Illinois University.  During my playing career under, Jim Schmitz, I was able to finish as a pitcher 
      for the Panthers I ended my tenure as the Career Saves Leader (18), leader in appearances (102), 3rd in Wins (20), 4th in Innings Pitched (261.3) & 5th in 
      Strikeouts (210) for the University.  I was voted by the team and coaches on three separate occasions as the Pitcher of the Year.`,
      `After my playing career I began my coaching career with the Hounds Baseball Organization based out of Willowbrook, Illinois in 2017.  While there I was tasked 
      with coaching High School Level Travel Teams.  During that time, I grew my Coaching Network within the Twitter/X Space. With success of placing players within 
      my teams, growing my network, and ability to help other teams within our organization, I was promoted to the recruiting coordinator for the Hounds.`,
      `For the past 3 years, I transitioned into coaching for one of the biggest travel organizations in the state of Illinois (Cangelosi Sparks - Lockport).  While 
      there, I have continued coaching not only High School Level Elite Teams but been a key instructor for our youth programing.`
    ],
    twitter: 'https://x.com/ChrisVaculik',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['726_eastern_illinois_university.png'],
    careerHighlights: [
      "Coached for 10 years for some of Illinois' Top High School Travel Teams",
      "Have been promoted as a Recruiting Coordinator, and rolled out programs to help athletes get noticed and recruited.",
      'Strong background with the process, details, and "know how" on how to get recruited'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachchrisvaculik',
  },
  'dale-nelson': {
    photo: 'dale_nelson.png',
    fullName: 'Dale Nelson',
    title: 'College Baseball Advisor',
    bio: [
      `Coach Nelson grew up in Chesterfield, Va and attended Meadowbrook HS.  Nelson played 4 years of HS baseball and two 
      years of basketball while at Meadowbrook.  Nelson attended Averett University as a LHP and was part of program that had 
      first winning seasons and national ranking during his time there.  Dale graduated in 2002 with a Bachelor in Physical 
      Education and minor in coaching.  Nelson has been a Health/PE/Driver Education teacher for 20 years.`,
      `From 2014-2024 Coach Nelson was head Varsity Baseball Coach at Christiansburg HS.  From a program that didn't qualify 
      for regional play in over 20 years, Nelson helped lead the Blue Demons to multiple district championsships along with 
      regional and state apperances. Chrsitiansburg made the state tournmanet for forst time in school history in 2022. During 
      his tenure the Blue Demons won 130 games from 2015-2024.`,
      `From 2008-2014 Coach Nelson was an assistant at William Byrd and Cave Spring HS in Roanoke, those teams won 5 distrcit 
      titles, along with 2 regional champioships, and state quarterfinal and semifinal berths at Cave Spring in 2011-2012.`,
      `In 2002 Coach Nelson began his coaching career at Danville Community College as assistant coach. Nelson coached DCC from 
      2002-2007 and won 3 VCCS conference/tournament championships during that time.`,
      `Dale currently resides in Christiansburg, VA with his wife Stephanie and two kids`
    ],
    twitter: 'https://x.com/coach_nelson31',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['486000_danville_community_college.png','633_averett_university.png'],
    careerHighlights: [
      '6 district championships since 2014, 1st regional and state apperances in school history',
      '32 players from Christiansburg since 2014 signed to play college baseball',
      '4 Time River Ridge District- Coaching Staff of the year Honors',
      'Annual Commonwealth Games All Star Game Coaching Staff- West Team',
      'West Region committee member of Virginia Baseball Coaches Association',
      '23 years coaching college/high school baseball',
      'Drafted by Kalamazoo Kings- Frontier League -2003'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'Virginia Tech, Radford, Virginia Military Institute, William and Mary, Elon',
      'NCAA D2': 'Concord University, Emory and Henry, Ferrum College, UVA Wise, King University, University Charleston, Barton College',
      'NCAA D3': 'Averett University, Roanoke College, Southern Virginia',
      NAIA: 'Bluefield College',
      NJCAA: 'New River Community College, SouthWest Community College'
    },
    calendly: 'http://calendly.com/coachnelson531',
  },
  'keith-stubbs': {
    photo: 'keith_stubbs.png',
    fullName: 'Keith Stubbs',
    title: 'College Baseball Advisor',
    bio: [
      `I am Keith Stubbs, a seasoned baseball advisor with over 30 years of experience in developing
      young talent. Growing up in Newport News, Virginia, I excelled in both football and baseball and
      received a music scholarship to Hampton University, where I also faced the challenges of being
      a college athlete.`,
      `My coaching career began in Washington, D.C., at institutions like Maret School and Nationally
      Ranked Riverdale Baptist School in Prince Goerge’s County, Maryland. I played a pivotal role in
      Major League Baseball’s Reviving Baseball in Inner Cities (RBI) Program. As the director of the
      DC RBI program, we produced 12 professional players and helped over 300 secure college
      placement and scholarships. I was awarded an opportunity to attend Major League's Baseball
      Scout Development Program.`,
      `As an area scout for the Philadelphia Phillies 19 years and Anaheim Angels 2 years, I focused
      on discovering talent in Maryland, D.C., and Virginia. I also served as the Director of On-Field
      Sessions for Baseball Factory and established the Mid-Atlantic Philadelphia Phillies Scout
      Team, providing critical exposure for young athletes.`,
      `In addition to my scouting work, I have extensive college coaching experience at Prince
      George's Community College and Howard University, as well as volunteering at Catholic
      University. My involvement with the National Scout Report and the Cal Ripken Sr Foundation,
      where I developed a college recruitment showcase program, further enriches my background.`,
      `In recent years, I transitioned away from baseball to work with SkillShow, a leading provider of
      professional videos for aspiring athletes. I’m now excited to take on a new role as an advisor
      with SportsForce, where I can leverage my diverse experiences to guide young athletes in their
      journeys.`,
      `I also traveled to Panama to promote academic achievement through sports. Currently, I
      co-founded "Field of Dreams," an after-school program in Southeast Washington, D.C.,
      dedicated to mentoring underserved youth. My mission is to empower aspiring athletes, guiding
      them through the complexities of college recruiting while making a positive impact in their
      communities.`
    ],
    twitter: 'https://x.com/StubbsScout',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['mlb.png','phillies_logo.png','angels_logo.png','bowie_state_logo.png','prince_georges_logo.jpeg'],
    careerHighlights: [
      'Former Major League Scout with 21 years of experience (19 with the Phillies, 2 with the Angels).',  
      'Coaching Experience at Bowie State University, Prince George’s Community College, and multiple travel teams.',  
      'Leadership Roles** include Director of Baseball Operations at Pro Youth Foundation and Director of On-Field Programs at Baseball Factory.',
      'Video Coach for Skillshow, specializing in player analysis.',
      'Recruiting Expertise** with MVP Baseball Recruiting, NSR, NPID, and NLI Recruiting.',
      'Community Impact** as former Director of DC RBI program, helping 12 players get drafted and 500+ play in college.'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachkstubbs22',
  },
  'tanner-lane': {
    photo: 'tanner_lane.png',
    fullName: 'Tanner Lane',
    title: 'College Baseball Advisor',
    bio: [`
      Tanner is a Webb City, Missouri native who was fortunate enough to grow up under the instruction of San 
      Diego Padres Player Development Coordinator, Dave Bingham. After his career as a Cardinal, Lane took his 
      talents to Fort Scott CC for 1 year and then transferred to Pittsburg State University where he finished 
      his career as a Gorilla. Tanner has given private instructions for 7 years now and has previous coaching 
      experience for 2 years. Lane was a left handed pitcher in college who excelled in the MIAA. Tanner is excited 
      to be apart of this program and share his passion and wealth of knowledge of baseball to help the next 
      generation live out their dreams of playing college baseball. Tanner has a true passion for baseball and 
      wanting to help kids reach their full potential of playing at the next level. 
      `],
    twitter: 'https://x.com/Tanner_Lane5',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['904_pittsburg_state_university.png','1685_fort_scott_community_college.png'],
    careerHighlights: [
      'Walk on at Pitt to Scholarship in first year',
      'Single season save record of 13 in 2019',
      '2019 Second Team All MIAA',
      '2019 All Region Honors',
      '2019 Northwoods League All-Star Team',
      '2022 All MIAA Honors'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coach-tanner-lane',
  },
  'blake-sandford': {
    photo: 'blake_sandford.png',
    fullName: 'Blake Sandford',
    title: 'College Baseball Advisor',
    bio: [`
      Coach Sandford - 30 + years at the high school level`,
      `A former player, assistant coach, head coach, athletic director and administrator here in Texas. I am in demand to folks all across 
      the country as I continue to mentor young men and women in areas of leadership, culture change, and goal-setting. I use practical 
      experiences and down-home charm to continue to motivate students, coaches and communities to achieve at the highest level, and to 
      always seek new paths for success in challenging environments. I have been most successful in helping bring championship level baseball 
      to the high school game.`,
      `Additionally, I have been in demand helping coaches coach. I was a Try Out Coordinator for the Reds for 11 years, running the eval 
      camps and grading arms, and I was the infield coach at Howard Payne as well as working with the hitters.`
      ],
    twitter: 'https://x.com/CoachSandford',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['778_howard_payne_university.png'],
    careerHighlights: [
      'Multiple Coach of the Year awards', 
      'Regional Coach of the Year', 
      'UIL Sponsor Excellence Award winner',
      'THSCA ROCK Mentor'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'Harvard, Columbia, Cornell, Vanderbilt, UNC, Duke, Clemson, Northeastern, Boston College, UConn, Rutgers',
      'NCAA D3': 'Amherst, Colby, Endicott, Salve Regina',
      NJCAA: 'NECC, San Jancinto',
    },
    calendly: 'https://calendly.com/coachsandford',
  },
  'jonathan-shiver': {
    photo: 'jonathan_shiver.png',
    fullName: 'Jonathan Shiver',
    title: 'College Baseball Advisor',
    bio: [
      `Jonathan  was a two sport varsity athlete for three years at Middleburg High School in Middleburg, FL. Jonathan attended 
      Trinity Baptist College in Jacksonville, FL. There he earned All-Conference Honors all four years and was an All-American 
      in 2017 as a two way player. Earning his B.A. in Business Management and Ethics from Trinity Baptist College, he then got 
      his Masters degree from Olivet Nazarene University in Organizational Leadership.`, 
      `In 2018, Jonathan began his coaching career at Trinity Baptist College from 2018-2020. Then he went to Olivet Nazarene 
      University from 2020-2024. He now coaches travel and high school baseball in the Jacksonville area.`,
      `Jonathan currently resides in Jacksonville, FL.`
    ],
    twitter: 'https://x.com/CoachJ_Shiver',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['804_lander_university.png','Trinity_Baptist_College.png','1868_olivet_nazarene_university.png'],
    careerHighlights: [
      '4 Years Assistant Coach- NAIA Olivet Nazarene University',
      '2 All-Americans in four seasons at Olivet Nazarene University', 
      '17 All-Conference Players coached in 7 years as college coach',
      '2017 All-American as a player',
      '2025 HOF Inductee at Trinity Baptist College as a player'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'Jacksonville University',
      'NCAA D2': 'Middle Georgia State College, Lander University, Lee University',
      NAIA: 'Olivet Nazarene University, Warner University, Webber International University',
      NJCAA: 'Florida State College of Jacksonville, Santa Fe College',
    },
    calendly: 'https://calendly.com/coachjshiver',
  },
  'kevin-kies': {
    photo: 'kevin_kies.jpg',
    fullName: 'Kevin Kies',
    title: 'College Baseball Advisor',
    bio: [
      `Kevin is passionate about helping student-athletes reach the next level and believes in guiding players through both the 
      recruiting process and personal development. He’s committed to building lasting relationships with families and helping 
      athletes find the right college fit on and off the field.`,
      `Kevin has over a decade of experience coaching baseball at the collegiate, high school, and post-grad levels. He most 
      recently served as Director of Hitting at HITFORTH, a data-driven training facility in Austin, Texas, where he led private 
      and group instruction using advanced tools such as HitTrax, Blast Motion, and K-Vest. Kevin has also been a graduate assistant 
      coach at Kentucky Christian University and the head post-grad coach at Inspiration Academy, helping athletes earn college 
      opportunities across the country. His background includes summer collegiate head coaching roles, recruiting coordination, 
      and player development leadership.`
    ],
    twitter: 'https://x.com/Coach_Kies',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['485714_university_of_south_carolina_sallkenhatchie.png','1863_kentucky_christian_university.png, 1805_tyler_junior_college.png'],
    careerHighlights: [
      'Former Director of Hitting at HITFORTH, a tech-integrated private training facility in Austin, TX',
      'Head Coach of the Post-Grad Program at Inspiration Academy (FL)',
      'Graduate Assistant Coach – Kentucky Christian University (Offense, Catchers, Outfielders)',
      'Broke multiple school team and offensive records at KCU, including runs, home runs, and RBIs',
      '10+ years coaching experience across high school, collegiate, and post-grad levels',
      'Helped place dozens of athletes into college baseball programs nationwide',
      'Volunteer Assistant Baseball Coach at Tyler Junior College'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'University of Texas, University of Tennessee, Coastal Carolina University, Dallas Baptist University, Butler University, UNC Charlotte, Quinnipiac University, Niagra University, Monmouth University, Presbyterian College, The Citadel, Winthrop, Southern Illinois University, Mississippi Valley University, UMASS Lowell, Louisiana Tech, Western Carolina University, University of New Orleans, University of Northern Colorado, Western Kentucky University, Seton Hall University, Queens University of Charlotte, Stetson University, Radford University, Southeast Missouri State University, University of Southern Indiana, Virginia Commonwealth University, University of Pennsylvania, Lamar University',
      'NCAA D2': 'University of Tampa, Belmont-Abbey University, Jefferson University, Limestone University, St. Edwards University, USC Aiken, Concord University, Queens College, Franklin Pierce University, Arkansas Tech, Palm Beach Atlantic University, West Virginia State University, Flagler College, Edward Waters University, Eastern New Mexico University',
      'NCAA D3': 'Benedictine University, Rhodes College, Kenyon College, University of Mount Saint Vincent, Augustana College, Asbury University, University of Dallas, Covenant College, Mary Hardin-Baylor',
      NAIA: 'USC Beaufort, Kentucky Christian University, Johnson University, Central Baptist College, Indiana Tech, New College of Florida, Campbellsville University, Webber International, Toccoa Falls College, Avila University',
      NJCAA: 'El Paso CC, Paris JC, Angelina JC, College of Central Florida, Cuyahoga Community College, Lansing CC, Florida Southwestern College, St. Petersburg College, Mercer County CC, Pasco Hernando State College, College of Southern Maryland, Bucks County CC, UCONN Avery Point, Minnesota West, Cloud County CC, Indian Hills CC, Tyler Junior College, Morton College, Midland College, Cerro Coso CC',
    },
    calendly: 'https://calendly.com/coachkies2',
  },
  'jared-bennett': {
    photo: 'jared_bennett.png',
    fullName: 'Jared Bennett',
    title: 'College Baseball Advisor',
    bio: [
      `Jared played High School baseball in his hometown of Corsicana, Texas. After high school Jared played collegiate 
      baseball at Tarleton State University in Stephenville, Texas under Hall of Fame Coach Jack Allen. In 2008, Jared began his 
      coaching career when he coached a collegiate summer team out of Moore, Oklahoma that was a part of the National Baseball 
      Congress. From 2008 to 2021 Jared had multiple coaching stops. He had stints as a collegiate summer league coach, junior 
      high baseball coach, club baseball head coach, and a league president and tournament coordinator. In 2022 he began as an 
      assistant with Randall University in Moore, Oklahoma. He took over the Head Coaching role with Randall in 2023. And he also 
      served as the hitting and 3B Coach for the Liberal Bee Jays in 2025. Jared currently resides in Newcastle, Oklahoma.`
    ],
    twitter: 'https://x.com/jaredb_bsbl?s=21&t=zuOTzMRkhyEBmw48dwMMTw',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['965_tarleton_state_university.png','Randall_University.png',],
    careerHighlights: [
      '17 years coaching experience',
      'Helped over 60 players in 3 years get an opportunity to play college baseball',
      'Multiple All-Conference players',
      '2 players sign Independent League Contracts in 3 years'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/app/scheduling/meeting_types/user/me',
  },
  'austin-wheeler': {
    photo: 'austin_wheeler.jpg',
    fullName: 'Austin Wheeler',
    title: 'College Baseball Advisor',
    bio: [
      `My name is Austin Wheeler, and I am from St. Catharines, Ontario, Canada. My journey in college baseball began in 2016, 
      when I competed as an outfielder at Erie Community College in Williamsville, New York. In 2021, I attended Graceland 
      University in Lamoni, Iowa, where I competed as an outfielder in the NAIA. As a member of the leadership council at 
      Graceland, I graduated in 2023 with a Bachelor of Business Administration and Sport Management, achieving a 4.0 GPA. 
      In 2023, I attended York University (another NAIA in Nebraska) and served as a graduate assistant and the Head Coach for 
      the Varsity Reserve baseball program.`,
      `In August 2025, I will graduate with a Master of Arts in Organizational and Global Leadership, with a 4.0 GPA as well. 
      During the summer months in York, Nebraska, I have enjoyed coaching American Legion baseball as the Head Coach for the 
      Junior Cornerstone Kings. Student-athlete development is something I take pride in and am passionate about. As a Canadian 
      who has traveled to the United States to play college baseball at multiple levels, I understand the importance of personal 
      development and finding the right program. My goal now is to help student-athletes throughout North America find a place 
      they can call home for two and/or four years.`
    ],
    twitter: 'https://x.com/arwheeler6',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['485000_erie_community_college.png', '1690_graceland_university.png'],
    careerHighlights: [
      '2018 recipient of the Coaches Award at Erie Community College, presented by NJCAA President Joe Bauth',
      '2023 member of the leadership council for the baseball program at Graceland University (IA)',
      '2023-2025 Graduate Assistant/Head Varsity Reserve Coach at York University (NE) having a combined record of 19-25-1',
      '2025 runner-up in the Kansas Collegiate Athletic Conference Tournament',
      '2023-2025 Head Junior Coach for Cornerstone Kings, having a combined record of 27-12'
    ],
    myPlayerCollegesByDivision: {
      NJCAA: 'Erie Community College, Herkimer Community College'
    },
    calendly: 'https://calendly.com/coachwheeler6',
  },
  'will-edwards': {
    photo: 'will_edwards.jpg',
    fullName: 'Will Edwards',
    title: 'College Baseball Advisor',
    bio: [
      `I have been involved in baseball since the age of 3 and have played/coached at multiple levels. I have a passion for seeing 
      athletes achieve their goals and playing at the collegiate and professional level. I have extensive experience involved in
      recruiting at the collegiate and high school levels and look forward to helping families and players find their perfect match 
      to continue their athletic careers and grow as a baseball player and person overall.`
    ],
    twitter: 'http://x.com/@wbe_34',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['East_Mississippi_Community_College.png', '284_millsaps_college.png'],
    careerHighlights: [
      '4 year lettermen at Kosciusko High School 2006-2009',
      '2 year starting pitcher at East Mississippi Community College 2010-2011',
      '2 year starting pitcher at Millsaps College 2012-2013',
      '2 time all conference 1st team 2012-2013',
      '2nd team all south region 2013',
      '2013 D3 World Series starting pitcher',
      'Assistant Coach at Millsaps College 2014-2016',
      'Pitching Coach at Captain Shreve HS 2017-2025'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'ULM/Marshall, McNeese, Alabama A&M University, Grambling',
      'NCAA D3': 'Mississippi College, Mississippi College, Belhaven University, Belhaven University, Centenary College, Centenary College, Centenary College, Centenary College',
      NJCAA: 'Bossier Parish Community College, Holmes Community College, Baton Rouge Community College, Southeastern Arkansas Community College, Southern Arkansas Community College, Dallas College Brookhaven, Southwest Mississippi Community College, Southern Arkansas Technical Community College',
    },
    calendly: 'http://calendly.com/willedwards34517',
  },
  'gabriel-alfaro': {
    photo: 'gabriel_alfaro.png',
    fullName: 'Gabriel Alfaro',
    title: 'College Baseball Advisor',
    bio: [`
      Gabriel spent seven years as a NCAA Division I coach with Florida International University (FIU), where a major accomplishment occurred in 
      2017 when he helped lead the program to sign the No. 1 recruiting class in the nation, as ranked by Perfect Game. This elite class included 
      future Major Leaguers MJ Melendez and Heliot Ramos, as well as second-round pick Logan Allen.`,
      `With a strong background in evaluating high school and junior college talent across the country, Alfaro possesses a deep understanding of the 
      qualities college coaches seek. Currently, he is leveraging this expertise in professional baseball, working in his second year with the Miami 
      Marlins Baseball Operations department.`
    ],
    twitter: 'https://x.com/Gabe_Alfaro23',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['748_florida_international_university.png'],
    careerHighlights: [
      '6 Years experience as a D1 Assistant Coach',
      'Over 50 players drafted in the MLB draft',
      '10 former players reached the Major League Level'
    ],
    myPlayerCollegesByDivision: {},
    calendly: 'https://calendly.com/coachalfaro23',
  },
  'wesley-jones': {
    photo: 'wesley_jones.jpeg',
    fullName: 'Wesley Jones',
    title: 'College Baseball Advisor',
    bio: [`
      Wesley Jones is a lifelong baseball professional from East Tennessee whose passion for the game began at a young age. 
      He played collegiate baseball at Milligan College, where he still holds several school baseball records, before 
      continuing his playing career for three years in professional independent leagues.`,
      `Following his playing days, Wesley has remained deeply involved in the sport, coaching at all levels of the game and 
      working hands-on in player development. He is the founder and owner of Net Elite Sports, a premier baseball 
      organization dedicated to providing high-level tournament opportunities for high school athletes and helping them 
      compete, develop, and gain exposure at the next level.
      `],
    twitter: 'https://x.com/netelitebasebal',
    facebook: '',
    instagram: '',
    linkedin: '',
    logoList: ['1753_milligan_college.png'],
    careerHighlights: [
      'Single season and career stolen base, runs scored, total bases record at Milligan College', 
      'Second team all American at Milligan college',
      '2x All conference Milligan College', 
      '3 years playing career after college'
    ],
    myPlayerCollegesByDivision: {
      'NCAA D1': 'University of Tn, East Tn University, South Carolina Univerisity, Vanderbilt University, Radford University ',
      'NCAA D2': 'Carson Newman University, Tusculum University, King University, Lee University',
      'NCAA D3': 'Maryville College',
      NAIA: 'Milligan University, Wesleyan University, Bryan University, Union University, Blue Field University ',
      NJCAA: 'Walter State, Cleveland State, Chatt State, Vol State, Motlow State',
    },
    calendly: 'https://calendly.com/coachwbjones10/30min',
  }
  // 'advisor-name': {
  //   photo: '',
  //   fullName: '',
  //   title: 'College Baseball Advisor',
  //   bio: [],
  //   twitter: '',
  //   facebook: '',
  //   instagram: '',
  //   linkedin: '',
  //   logoList: [],
  //   careerHighlights: [],
  //   myPlayerCollegesByDivision: {
  //     'NCAA D1': '',
  //     'NCAA D2': '',
  //     'NCAA D3': '',
  //     NAIA: '',
  //     NJCAA: '',
  //   },
  //   calendly: '',
  // },
};
